const MAX_PERCENTAGE = 100;

const formatDeposit = (deposit, setup) => {
  const { amountType, directDeposits, isCanada, paperless, delivery } = setup;
  const getSumPercentages = () => {
    if (directDeposits?.length > 1 && amountType === '%') {
      const value = item => parseInt(item.splitPercentage, 10) || 0;
      const splitAccounts = directDeposits.filter(a => !a.primary);
      return splitAccounts.reduce((memo, item) => memo + value(item), 0);
    }
    return 0;
  };

  const { primary, __typename, forCorps, ...rest } = deposit;
  const percentage = amountType === '%';
  let splitPercentage = 0;
  if (percentage) {
    splitPercentage = primary
      ? MAX_PERCENTAGE - getSumPercentages(forCorps)
      : parseInt(deposit.splitPercentage, 10);
  } else {
    splitPercentage = primary ? 100 : 0;
  }
  return {
    ...rest,
    currencyType: deposit.currencyType || 'US',
    bankAccountType: parseInt(deposit.bankAccountType, 10),
    isPaperLess: isCanada ? false : paperless,
    isDeliveryRequested: isCanada ? true : delivery,
    flatAmount:
      amountType === '$' && !primary ? parseInt(deposit.flatAmount, 10) : 0,
    splitPercentage: splitPercentage,
    forCorps,
  };
};

export default formatDeposit;
